var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSoundcloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2655 3986 c-41 -18 -83 -69 -90 -109 -3 -18 -4 -622 -3 -1344 3 -1307 3 -1312 24 -1339 11 -15 33 -37 48 -48 27 -21 34 -21 919 -21 821 0 897 1 956 18 299 82 506 290 588 588 13 47 18 99 17 194 -1 111 -4 143 -28 220 -108 357 -448 596 -814 572 -48 -3 -94 -8 -103 -12 -14 -5 -18 4 -24 52 -16 139 -74 318 -148 462 -161 315 -460 578 -787 693 -208 73 -475 109 -555 74z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2015 3666 c-41 -18 -83 -69 -90 -109 -3 -18 -4 -550 -3 -1184 3 -1145 3 -1152 24 -1179 39 -53 71 -69 134 -69 63 0 95 16 134 69 21 27 21 31 21 1206 0 1175 0 1179 -21 1206 -11 15 -32 37 -46 47 -33 25 -113 32 -153 13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M735 3026 c-41 -18 -83 -69 -90 -109 -3 -18 -5 -406 -3 -864 3 -822 3 -832 24 -859 39 -53 71 -69 134 -69 63 0 95 16 134 69 21 27 21 34 21 886 0 852 0 859 -21 886 -11 15 -32 37 -46 47 -33 25 -113 32 -153 13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1375 3026 c-41 -18 -83 -69 -90 -109 -3 -18 -5 -406 -3 -864 3 -822 3 -832 24 -859 39 -53 71 -69 134 -69 63 0 95 16 134 69 21 27 21 34 21 886 0 852 0 859 -21 886 -11 15 -32 37 -46 47 -33 25 -113 32 -153 13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95 2546 c-41 -18 -83 -69 -90 -109 -3 -18 -5 -262 -3 -544 3 -499 4 -512 24 -539 39 -53 71 -69 134 -69 63 0 95 16 134 69 21 27 21 38 21 566 0 528 0 539 -21 566 -11 15 -32 37 -46 47 -33 25 -113 32 -153 13z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoundcloud);
export default __webpack_public_path__ + "static/media/soundcloud.e11112108ebe99bbd6807f9775611779.svg";
export { ForwardRef as ReactComponent };